import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesLandingExplorer: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-landing-explorer`),
};

export default pagesLandingExplorer;
